
import { defineComponent } from "vue";
import {
  CogIcon,
  BellIcon,
  SearchIcon,
  CreditCardIcon,
} from "@heroicons/vue/outline";
import AppButton from "@/common/components/AppButton.vue";
import AppLogoIcon from "@/common/components/Icon/AppLogoIcon.vue";
import { useWallet } from "@/common/composables/useWallet";

export default defineComponent({
  components: {
    AppLogoIcon,
    CogIcon,
    BellIcon,
    SearchIcon,
    CreditCardIcon,
    AppButton,
  },
  setup() {
    const wallet = useWallet();

    return { wallet };
  },
});
